<template>
  <b-row class="auth-container">
    <b-col v-if="$apollo.queries.company.loading || !company" class="d-flex justify-content-center">
      <loading-spinner/>
    </b-col>
    <b-col v-else-if="useOneCol" class="d-flex justify-content-center">
      <component class="card-width mx-auto" :is="focus" :company="company"
        :emailAddress="emailAddress" @setEmailAddress="e => emailAddress = e"/>
    </b-col>
    <template v-else>
      <b-col cols="12" md="6">
        <component class="card-width mx-auto mr-md-0 px-1 py-2" :is="focus" :company="company"
          :emailAddress="emailAddress" @setEmailAddress="e => emailAddress = e"/>
      </b-col>
      <template v-if="$root.isCXR">
        <b-col v-if="$route.name === 'Register'" cols="12" md="6" class="my-5 mt-md-1 mx-auto ml-md-0 pt-4 card-width">
          <h3 class="text-center pb-3">{{ $t('auth.register.info.title') }}</h3>

          <template v-if="$te('auth.register.info.content') && isLocaleObject($t('auth.register.info.content'))">
            <div v-for="(line, index) in $t('auth.register.info.content')" class="d-flex flex-row align-items-start" :key="index">
              <div class="rounded-circle px-1 mt-1 mr-2 primary-background-color text-white">
                <font-awesome-icon icon="check" size="sm"/>
              </div>
              <div class="d-flex flex-column">
                <p>{{ line }}</p>
              </div>
            </div>
          </template>

          <div class="embed-responsive embed-responsive-16by9 card-width">
            <iframe class="embed-responsive-item" frameborder="0" src="https://player.vimeo.com/video/806595288?h=976fca6404"></iframe>
          </div>
        </b-col>
        <b-col v-else cols="12" md="6" class="my-5 mt-md-1">
          <div class="embed-responsive embed-responsive-16by9 card-width">
            <iframe class="embed-responsive-item" frameborder="0" src="https://player.vimeo.com/video/806595288?h=976fca6404"></iframe>
          </div>
        </b-col>
      </template>
      <template v-else>
        <b-col v-if="$route.name === 'Register'" cols="12" md="6" class="my-5 mt-md-1 mx-auto ml-md-0 pt-4 card-width">
          <h3 class="text-center pb-3">{{ $t('auth.register.info.title') }}</h3>

          <template v-if="$te('auth.register.info.content') && isLocaleObject($t('auth.register.info.content'))">
            <div v-for="(line, index) in $t('auth.register.info.content')" class="d-flex flex-row align-items-start" :key="index">
              <div class="rounded-circle px-1 mt-1 mr-2 primary-background-color text-white">
                <font-awesome-icon icon="check" size="sm"/>
              </div>
              <div class="d-flex flex-column">
                <p>{{ line }}</p>
              </div>
            </div>
          </template>

          <div class="text-center text-md-left">
            <b-img fluid :src="registerImage"/>
          </div>
        </b-col>
        <b-col v-else cols="12" md="6" class="my-5 mt-md-1 text-center text-md-left">
          <b-img fluid :src="loginImage"/>
        </b-col>
      </template>
    </template>

    <b-col v-if="$root.isCXR" cols="12" class="my-5">
      <cxr-partner-logos/>
    </b-col>
  </b-row>
</template>

<script>
import _get from 'lodash/get';
import AuthenticateQuery from '@/graphql/queries/Authenticate.gql';
import CxrPartnerLogos from '@/components/success/cxr-partner-logos';
import LoadingSpinner from '@src/components/misc/LoadingSpinner';
import i18nMixin from '@src/mixins/i18n';

export default {
  props: {
    userInviteID: {
      type: String,
      default: () => null,
    },
    userReferrerID: {
      type: String,
      default: () => null,
    },
  },
  components: {
    LoadingSpinner,
    CxrPartnerLogos,
  },
  mixins: [
    i18nMixin,
  ],
  data: () => ({
    emailAddress: null,
  }),
  apollo: {
    company: {
      query: AuthenticateQuery,
      variables() {
        const { userInviteID, userReferrerID } = this;
        return { userInviteID, userReferrerID };
      },
      error(err) {
        this.fatalErr = err;
      },
      prefetch: true,
    },
  },
  computed: {
    focus() {
      const { matched: [ parent ] } = this.$route;
      return parent && parent.components && parent.components.focus;
    },
    useOneCol() {
      const { name } = this.$route;
      return [ 'LoginSSO', 'Logout' ].includes(name);
    },
    loginImage() {
      return _get(this.company, 'authBranding.loginImage.fileLocation', '/static/images/illustrations/1.svg');
    },
    registerImage() {
      return _get(this.company, 'authBranding.registerImage.fileLocation', '/static/images/illustrations/1.svg');
    },
  },
  watch: {
    emailAddress(value) {
      if (value === null) {
        const { query } = this.$route;
        this.$router.push({ name: 'Login', query });
      }
    },
  },
};
</script>

<style lang="scss">
.auth-container {
  $max: 500px;

  .card-width {
    max-width: $max;
    width:100%;
  }
  img.fluid {
    max-height: $max;
    max-width: $max;
  }

  .email-change-btn {
    background-color: #e9ecef;
    border: 1px solid #ced4da;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Auth/Container.vue